<template>
  <section class="home">
    <div class="mid-content">
      <Storagestatus />
      <folder />
    </div>
  </section>
</template>
<script>
import Storagestatus from '../components/Storagestatus';
import folder from '../components/folder';
import '../js/loading-bar.js';  
export default {
  name: 'Home',
  components: {
    folder,
    Storagestatus,
  },
  mounted(){
    document.getElementById('search').value = ''
    this.$store.commit('setSearchValue', false);
    this.$store.commit('NameNavigationRoute', 'remove');
  }
};
</script>
